import { Flex, Box, Button } from '@radix-ui/themes';
import { Outlet } from 'react-router-dom';
import ConsoleHeader from '../components/shared/ConsoleHeader';
import ConsoleSidebar from '../components/shared/ConsoleSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { updateFinance } from '../redux/slices/financeSlice';
// import { updateNotifications } from '../redux/slices/userSlice';
import { useEffect, useCallback } from 'react';
import api from '../api';
import { updatePaymentDetails } from '../redux/slices/accountSlice';
import { saveDeviceToken } from '../services/authService';
import { generateToken, messaging } from '../firebase/firebase';
import { onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import CustomToast from '../components/common/CustomToast';
import { notificationService } from '../services/notificationService';
import { userService } from '../services/userService';

import { updateUser } from '../redux/slices/userSlice'
import { updateAccount } from '../redux/slices/accountSlice'
import { updateStudentAccount } from '../redux/slices/studentAccountSlice'
import { updateGuardian } from '../redux/slices/guardianSlice'

export default function ConsoleLayout({ role }) {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const studentAccount = useSelector(state => state.studentAccount);

    if (!user) {
        return <div>Loading...</div>; // Or your loading component
    }

    useEffect(() => {
        checkAndSaveDeviceToken();

        if (user.details.role == 'teacher' || user.details.role == 'school') {
            handleGetFinance();
        }

    }, [user.details.role]);


    // Fetch student payment details when user is a student. And also when the school changes
    useEffect(() => {
        if (user.details.role == 'student') {
            handleGetPaymentDetails();
        }

    }, [user.details.role, studentAccount.school]);

    const fetchUserData = async () => {
        try {
            const data = await userService.getUserData(user.details.id);
            console.log('data:', data);
            dispatch(updateUser({ ...data.user, account: data.account.details }));
            dispatch(updateAccount(data.account));

            switch (data.user.details.role) {
                case 'student':
                    dispatch(updateStudentAccount(data.account))
                    break
                case 'guardian':
                    console.log('guardian data', data);
                    dispatch(updateGuardian(data.account))
                    break;
                default:
                    console.log('No specific role action defined');
                    break
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };


    useEffect(() => {
        const unsubscribe = onMessage(messaging, (payload) => {
            toast(CustomToast, { data: payload.notification });
            console.log('Message received. ', payload);


            switch (payload.data.action) {
                case 'fetchUserData':
                    fetchUserData();
                    break;
                default:
                    console.log('No action specified in notification');
            }

            // dispatch(updateNotifications(payload));
        });

        return () => {
            unsubscribe();
        };
    }, []);

    const updateNotifications = useCallback(async () => {
        try {
            const response = await notificationService.getUnreadNotifications();
            // console.log('UNREAD NOTIFICATIONS response', response.data);
            dispatch(updateNotifications([...user.notifications, ...response]));
        } catch (error) {
            console.log(error);
        }
    }, [user.notifications, dispatch]);


    const checkAndSaveDeviceToken = async () => {
        const token = localStorage.getItem('device_token');
        if (token) {
            await saveDeviceToken(token);
        }
    }

    const handleGetFinance = async () => {
        try {
            const response = await api.get('/accounts/finance');
            console.log('get finance response', response.data);
            let pendingWithdrawalAmount = 0;
            if (response.data.finances.withdrawals.length > 0) {
                response.data.finances.withdrawals.map((withdrawal => {
                    if (withdrawal.status == 'pending') {
                        pendingWithdrawalAmount += withdrawal.amount
                    }
                }));
            }

            dispatch(updateFinance({
                account: response.data.finances.account,
                withdrawals: response.data.finances.withdrawals,
                credits: response.data.finances.credits,
                availableBalance: response.data.finances.account.balance - pendingWithdrawalAmount
            }))
        } catch (error) {
            console.log(error);
        }
    }




    const handleGetPaymentDetails = async () => {
        try {
            const response = await api.get('/payment-details');
            console.log('get payment details response', response.data);
            dispatch(updatePaymentDetails(response.data))
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <Box
            align="center"
            style={{ background: 'var(--gray-6)' }}
        >
            <Flex direction="row" flex="1" maxWidth="1080px" align="start">
                <ConsoleSidebar role={role} />
                <Flex direction='column' grow="1"
                    style={{
                        height: '100%',
                        flexGrow: 1,
                    }}
                >
                    <ConsoleHeader />
                    <Flex width="100%" maxWidth="1080px" minHeight="100vh" p='4' style={{
                        flex: 1,
                        paddingBottom: '80px'
                    }}>
                        <Outlet />
                    </Flex>
                </Flex>
            </Flex>
        </Box>
    );
} 